import EastIcon from "@mui/icons-material/East";
import { ButtonColor, ButtonIcon } from "@/constants/button";
import type { Theme } from "@/types/theme";
import type { SvgIconTypeMap } from "@mui/material";
import type { OverridableComponent } from "@mui/material/OverridableComponent";

export type Icon = OverridableComponent<SvgIconTypeMap> & {
  muiName: string;
};

export function getButtonStyles(
  color: ButtonColor,
  styles: Theme["buttonSettings"],
) {
  switch (color) {
    case ButtonColor.Primary:
      return styles.styles.primary;

    case ButtonColor.Secondary:
      return styles.styles.secondary;

    case ButtonColor.Tertiary:
      return styles.styles.tertiary;

    case ButtonColor.Quaternary:
      return styles.styles.quaternary;
  }
}

export function getButtonIcon(icon?: ButtonIcon): Icon | null {
  switch (icon) {
    case ButtonIcon.Arrow:
      return EastIcon;

    default:
      return null;
  }
}
